import React from 'react';
import {
    ProgressBreadcrumbCompletedDisplayStyle,
    ProgressBreadcrumbList,
    ProgressBreadcrumbListTheme,
} from '@apply/components';
import { WIZARD_STEPS, WizardStepId, stepIndex } from './steps';

interface WizardSidebarProps {
    currentStepId: WizardStepId;
    completedStepIds: WizardStepId[];
    onStepClick?: (stepId: WizardStepId) => void;
    orientation?: 'vertical' | 'horizontal';
}

export const WizardSidebar: React.FC<WizardSidebarProps> = ({
    currentStepId,
    completedStepIds,
    onStepClick,
    orientation = 'vertical',
}) => {
    const currentIndex = stepIndex(currentStepId);

    const crumbs = WIZARD_STEPS.map((step, index) => {
        // Steps already completed, or passed, are navigable
        const isNavigable = !!onStepClick && (completedStepIds.includes(step.id) || index < currentIndex);

        return {
            id: `bpWizardCrumb_${step.id}`,
            number: index + 1,
            children: step.label,
            enabled: isNavigable,
            handleClick: isNavigable ? () => onStepClick?.(step.id) : undefined,
        };
    });

    return (
        <ProgressBreadcrumbList
            id='businessProfileWizard'
            theme={ProgressBreadcrumbListTheme.Blue}
            activeCrumbNumber={currentIndex + 1}
            crumbs={crumbs}
            orientation={orientation}
            completedCrumbDisplayStyle={ProgressBreadcrumbCompletedDisplayStyle.Checkmark}
        />
    );
};
